import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=41a8a93c&scoped=true"
import script from "./FAQs.vue?vue&type=script&lang=ts"
export * from "./FAQs.vue?vue&type=script&lang=ts"
import style0 from "./FAQs.vue?vue&type=style&index=0&id=41a8a93c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a8a93c",
  null
  
)

export default component.exports